import { PaginatedDataDTO } from '@bottega52/commons-pagination';
import SeamlessImmutable from 'seamless-immutable';
import { ICylinderInDTO } from '../../repository/jago/model/input/ICylinderInDTO';
import { IKeyInDTO } from '../../repository/jago/model/input/IKeyInDTO';
import { IMksImportInDTO } from '../../repository/jago/model/input/IMksImportInDTO';
import { ICsvPreviewInDTO } from '../../repository/jago/model/input/ICsvPreviewInDTO';
import { IMechanicalCylinderKeyRelationInDTO } from '../../repository/jago/model/input/IMechanicalCylinderKeyRelationInDTO';
import { IDomainOptionDTO } from '../../repository/jago/model/input/IDomainOptionDTO';
import { IMKSRequestDTO } from '../../repository/jago/model/output/IMKSRequestDTO';
import { MksActionsType } from './mks.actions';
import MksActionTypesEnum from './model/MksActionTypesEnum';

export interface IMksInterface {
  cylinders: {
    data: PaginatedDataDTO<ICylinderInDTO> | {};
    selectedCylinder: ICylinderInDTO | {};
  },
  keys: {
    data: PaginatedDataDTO<IKeyInDTO> | {};
    selectedKey: IKeyInDTO | {};
  },
  imports: {
    data: PaginatedDataDTO<IMksImportInDTO> | {};
    selectedImport: IMksImportInDTO | {};
    lastImport: IMksImportInDTO | {};
  },
  relations: {
    data: PaginatedDataDTO<IMechanicalCylinderKeyRelationInDTO> | {};
  },
  csvPreview: ICsvPreviewInDTO | {};
  selectedHostname: string;
  selectedDomain: IDomainOptionDTO | null;
  mksRequests: {
    data: PaginatedDataDTO<IMKSRequestDTO> | {};
    selectedRequest: IMKSRequestDTO | {};
    requestDetail: IMKSRequestDTO | {};
    exportedRequests: IMKSRequestDTO[];
  };
}

const initialState = SeamlessImmutable<IMksInterface>({
  cylinders: {
    data: {},
    selectedCylinder: {},
  },
  keys: {
    data: {},
    selectedKey: {},
  },
  imports: {
    data: {},
    selectedImport: {},
    lastImport: {},
  },
  relations: {
    data: {},
  },
  csvPreview: {},
  selectedHostname: '',
  selectedDomain: null,
  mksRequests: {
    data: {},
    selectedRequest: {},
    requestDetail: {},
    exportedRequests: [],
  },
});

// eslint-disable-next-line import/no-anonymous-default-export
export default function(state: SeamlessImmutable.ImmutableObject<IMksInterface> = initialState, action: MksActionsType) {
  switch (action.type) {
    case MksActionTypesEnum.SAVE_CYLINDERS:
      return state.setIn(['cylinders', 'data'], action.payload);
    case MksActionTypesEnum.SET_SELECTED_CYLINDER:
      return state.setIn(['cylinders', 'selectedCylinder'], action.payload);
    case MksActionTypesEnum.SAVE_KEYS:
      return state.setIn(['keys', 'data'], action.payload);
    case MksActionTypesEnum.SET_SELECTED_KEY:
      return state.setIn(['keys', 'selectedKey'], action.payload);
    case MksActionTypesEnum.SET_SELECTED_HOSTNAME:
      return state.set('selectedHostname', action.payload);
    case MksActionTypesEnum.SET_SELECTED_DOMAIN:
      return state.set('selectedDomain', action.payload);
    case MksActionTypesEnum.SAVE_IMPORTS:
      return state.setIn(['imports', 'data'], action.payload);
    case MksActionTypesEnum.SET_SELECTED_IMPORT:
      return state.setIn(['imports', 'selectedImport'], action.payload);
    case MksActionTypesEnum.SAVE_LAST_IMPORT:
      return state.setIn(['imports', 'lastImport'], action.payload);
    case MksActionTypesEnum.SAVE_CSV_PREVIEW:
      return state.set('csvPreview', action.payload);
    case MksActionTypesEnum.CLEAR_CSV_PREVIEW:
      return state.set('csvPreview', {});
    case MksActionTypesEnum.SAVE_RELATIONS:
      return state.setIn(['relations', 'data'], action.payload);
    case MksActionTypesEnum.RESET_MKS_DATA:
      return state
        .setIn(['cylinders', 'data'], {})
        .setIn(['cylinders', 'selectedCylinder'], {})
        .setIn(['keys', 'data'], {})
        .setIn(['keys', 'selectedKey'], {})
        .setIn(['imports', 'data'], {})
        .setIn(['imports', 'selectedImport'], {})
        .setIn(['imports', 'lastImport'], {})
        .setIn(['relations', 'data'], {})
        .set('csvPreview', {});
    case MksActionTypesEnum.SAVE_MKS_REQUESTS:
      return state.setIn(['mksRequests', 'data'], action.payload);
    case MksActionTypesEnum.SET_SELECTED_MKS_REQUEST:
      return state.setIn(['mksRequests', 'selectedRequest'], action.payload);
    case MksActionTypesEnum.SAVE_MKS_REQUEST_DETAIL:
      return state.setIn(['mksRequests', 'requestDetail'], action.payload);
    case MksActionTypesEnum.UPDATE_MKS_REQUEST:
      return state.setIn(['mksRequests', 'requestDetail'], action.payload);
    case MksActionTypesEnum.DELETE_MKS_REQUEST:
      return state.setIn(['mksRequests', 'requestDetail'], action.payload);
    case MksActionTypesEnum.CHANGE_MKS_REQUEST_STATUS:
      return state.setIn(['mksRequests', 'requestDetail'], action.payload);
    case MksActionTypesEnum.EXPORT_MKS_REQUESTS:
      return state.setIn(['mksRequests', 'exportedRequests'], action.payload);
    case MksActionTypesEnum.RESET_MKS_REQUESTS_DATA:
      return state
        .setIn(['mksRequests', 'data'], {})
        .setIn(['mksRequests', 'selectedRequest'], {})
        .setIn(['mksRequests', 'requestDetail'], {})
        .setIn(['mksRequests', 'exportedRequests'], []);
    case MksActionTypesEnum.RESET_MKS_CYLINDERS_DATA:
      return state.setIn(['cylinders', 'data'], {});
    case MksActionTypesEnum.RESET_MKS_KEYS_DATA:
      return state.setIn(['keys', 'data'], {});
    case MksActionTypesEnum.RESET_MKS_RELATIONS_DATA:
      return state.setIn(['relations', 'data'], {});
    case MksActionTypesEnum.RESET_MKS_IMPORTS_DATA:
      return state.setIn(['imports', 'data'], {});
    default:
      return state;
  }
}
